<template>
    <div class="com-process">
        <div class="com-process-wrapper container">	
            <div class="com-title">合作流程<label>Cooperation Process</label></div>	
            <ul class="com-process__items block">
                <li class="com-process__item">
                    <img src="@/assets/cp-1.png">
                    <i><em></em></i>
                    <b>申请合作</b>点击 <a href="/merchant/apply?s=0">我要合作</a> 或电话<br>联系 <a href="tel:01213188285">01213188285</a>
                </li>	
                <li class="com-process__item">
                    <img src="@/assets/cp-2.png">
                    <i><em></em></i><b>系统演示</b>专人上门演示系统<br>操作流程
                </li>
                <li class="com-process__item">
                    <img src="@/assets/cp-3.png">
                    <i><em></em></i><b>签订合同</b>双方达成合作意向<br>签订合同
                </li>
                <li class="com-process__item">
                    <img src="@/assets/cp-4.png">
                    <i><em></em></i><b>对接信息</b>对接合作商线路<br>支付信息等
                </li>
                <li class="com-process__item">
                    <img src="@/assets/cp-5.png">
                    <i><em></em></i><b>正式上线</b>系统正式上线<br>祝您生意兴隆
                </li>			
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-process'
}
</script>

<style lang="less" scoped>
    .com-process {
        overflow: hidden;
        &__item {
            width: 20%;
            float: left;
            display: block;
            text-align: center;
            line-height: 1.44;
            color: #8193b5;
            img {
                width: 40%;
                color: #6c81a9;
            }
            i {
                display: block;
                position: relative;
                width: 100%;
                margin: .15rem 0;
                em {
                    display: inline-block;
                    width: .22rem;
                    height: .22rem;
                    background: #40bc66;
                    border-radius: .22rem;
                    z-index: 1;
                }
                &::after {
                    width: 100%;
                    display: block;
                    height: .1rem;
                    background: #c3e0cc;
                    content: '';
                    position: absolute;
                    top: .08rem;
                    z-index: -1;
                }
            }
            b {
                display: block;
                margin: .2rem 0 .1rem;
                font-size: .25rem;
                color: #333;
            }
            a {
                color: #40bc66;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        .com-process {
            &-wrapper {
                padding: 0 .3rem;
                box-sizing: border-box;
            }
            &__item {
                width: 100%;
                text-align: left;
                padding-left: 1rem;
                img {
                    width: 20%;
                    float: left;
                    margin-right: .3rem;
                }
                i {
                    position: absolute;
                    left: 0;
                    height: 2.2rem;
                    width: .3rem;
                    left: .4rem;
                    &::after {
                        height: 100%;
                        width: 30%;
                        top: 0;
                        left: .07rem;
                    }
                    em {
                        position: relative;
                        top: 37%;
                    }
                }
                b {
                    margin-top: .4rem;
                    font-size: .42rem;
                    font-weight: normal;
                }
                br {
                    display: none;
                }
            }
        }
    }
</style>


